import * as z from 'zod';

/**
 * Overrides the data-lake column name for a field (e.g. a foreign key `company` → `company_id`)
 * WITHOUT renaming the exportable JSON key. The JSON key is the `/v1/data-export` contract, so
 * renaming it would break existing consumers; this only changes the derived lake column, letting
 * the lake read more clearly than the model's historical field names. Merges with any existing
 * `.meta()`/`.describe()`.
 *
 * Pass the name already in the lake's snake_case form (it is used verbatim as the column name).
 */
export const lakeColumn = <T extends z.ZodType>(schema: T, name: string): T =>
  schema.meta({ ...(schema.meta() ?? {}), lakeColumn: name }) as T;
